import { RelevantDomains } from 'shared/lib/domains';
import { TaughtLesson } from 'shared/api/class-stats';
import { Brand } from 'shared/api/assignment-service';

const filterBySubjects = (
  lessons: TaughtLesson[] | null = null,
  subjects: RelevantDomains[] = [],
) =>
  subjects.length && lessons
    ? lessons.filter(
        (lesson) =>
          lesson.content.brand !== Brand.CUSTOM &&
          subjects.find((subject) => lesson.content.domain.startsWith(subject)),
      )
    : lessons;

export const filterLessons = (
  subjects: RelevantDomains[] = [],
  lessons?: TaughtLesson[] | null,
) => {
  return filterBySubjects(lessons, subjects);
};
